<template>

  <div>
    <div
      style="max-width: 520px;">
      <div v-if="!hasCustomer">
        Antes de adicionar a forma de pagamento, você precisa
        <router-link
          :to="{ path: '/billing/details' }">
          {{ $t('informar os dados de faturamento') }}
          </router-link>.
      </div>
      <ul
        v-if="hasCustomer"
        class="list-group list-group-flush">
        <li
          v-if="payableWith.includes('credit_card')"
          class="list-group-item px-3 py-4">
          <div class="mb-2">
            <span v-if="hasDefaultPaymethod" class="text-success"><i class="fas fa-check-circle" /></span>
            <span v-if="!hasDefaultPaymethod"><i class="far fa-check-circle" /></span>
            <b>Cartão de crédito (Automático)</b>
          </div>
          <BillingCredcard
            :isSteps="isSteps" />
        </li>
        <li
          v-if="payableWith.includes('bank_slip')"
          class="list-group-item px-3 py-4">
          <div class="mb-2">
            <span v-if="!hasDefaultPaymethod" class="text-success"><i class="fas fa-check-circle" /></span>
            <span v-if="hasDefaultPaymethod"><i class="far fa-check-circle" /></span>
            <b>Boleto ou PIX</b>
          </div>
          <div>Você poderá pagar por boleto ou PIX, assim que a fatura for gerada.</div>
          <div v-if="hasDefaultPaymethod" class="text-warning mt-2"><i>Para utilizar esse métodos, remova o cartão de crédito padrão.</i></div>
        </li>
      </ul>
    </div>
    <div
      v-if="isSteps"
      class="p-3">
      <button
        class="btn btn-primary"
        :disabled="!enableNext"
        @click="nextStep">
        {{ $t('Avançar') }}
        </button>
    </div>
  </div>

</template>

<script>
import BillingCredcard from './BillingCredcard'

export default {
  name: 'BillingPayment',
  components: {
    BillingCredcard
  },
  props: {
    isSteps: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    billingResume () {
      return this.$store.getters.getBillingResume
    },
    hasCustomer () {
      return this.billingResume.has_customer
    },
    hasDefaultPaymethod () {
      return this.billingResume.has_default_paymethod
    },
    selectedPlan () {
      return this.$store.getters.getBillingPlan
    },
    plan () {
      return this.isSteps ? this.selectedPlan : this.billingResume.plan
    },
    payableWith () {
      return this.plan.payable_with
    },
    enableNext () {
      if (this.plan.billing_mode === 'prepaid_credcard') {
        return this.billingResume ? this.billingResume.has_default_paymethod : false
      }
      return true
    }
  },
  created () {
  },
  methods: {
    nextStep () {
      this.$router.push('/billing/steps/finish')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingPayment.vue